type ImageProps = {
  src: string;
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
};

const Image = ({ src, alt, className, ...props }: ImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`max-w-full shrink-0 object-cover ${className}`}
      loading="lazy"
      {...props}
    />
  );
};

export default Image;
